<template>
  <MountingPortal mountTo="#outside">
    <div id="thirdslide" class="thirdslide">
      <div class="imageskill" style="display:flex;justify-content:center">
        <img src="../components/images/hero.svg" alt="Image" />
      </div>
      <div class="Wrapperdiv">
        <div class="headingsecondslide">
          Skills
          <div id="span"></div>
        </div>
        <div class="imageandstart" style="justify-content:center">
          <div class="fit">
            <template v-for="piece in forlloop">
              <v-tooltip bottom :color="piece[0]" :key="piece[0]">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mx2"
                    fab
                    dark
                    large
                    :style="{ background: piece[0] }"
                    :color="piece[0]"
                    v-bind="attrs"
                    v-on="on"
                    @click="activeTab = piece[1]"
                  >
                    <i :class="piece[2]" style="font-size:24px;"></i>
                  </v-btn>
                </template>
                <span>{{ piece[3] }}</span>
              </v-tooltip>
            </template>
          </div>
          <transition name="component-fade" mode="out-in">
            <component :is="activeTab"></component>
          </transition>
        </div>
      </div>
    </div>
  </MountingPortal>
</template>

<script>
import TabA from "./Tabs/TabA.vue";
import TabC from "./Tabs/TabC.vue";
import TabD from "./Tabs/TabD.vue";
import TabE from "./Tabs/TabE.vue";
import TabB from "./Tabs/TabB.vue";
export default {
  components: { TabA, TabB, TabC, TabD, TabE },
  name: "Thirdslide",
  data() {
    return {
      activeTab: "TabA",
      forlloop: [
        [
          "#ff5722",
          "TabA",
          "fas fa-keyboard",
          "Programming and Scripting Languages",
        ],
        ["indigo", "TabC", "far fa-file-code", "Frontend Development"],
        ["#4caf50", "TabD", "fab fa-bootstrap", "Frameworks & Libraries"],
        ["#ff5252", "TabE", "fas fa-toolbox", "Development Tools"],
        ["cyan", "TabB", "fab fa-markdown", "Markup Languages"],
      ],
    };
  },
};
</script>

<style scoped>
.imageandstart {
  /* font-family: "Poppins", sans-serif; */
  /* font-size: 1.2rem; */
  margin-left: 2.2vw;
  margin-right: 2.2vw;
  margin-bottom: 2vh;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0.3;
}
.fit {
  width: 90%;
  margin-left: 5%;
  display: flex;
  margin-bottom: 3vh;
  margin-top: 3vh;
  justify-content: space-between;
}
#span {
  width: 6vw;
  padding-bottom: 1vh;
  margin-bottom: 2vh;
  border-bottom: 4px solid rgb(47, 65, 223);
}
.headingsecondslide {
  font-size: 2.8rem;
  margin: 2.2vw;
  margin-bottom: 20px;
  font-family: "Zen Antique Soft", serif;
  color: #173b6c;
}
.thirdslide {
  margin-left: 22vw;
  width: 78vw;
  /* position: absolute; */
  /* top: 200vh; */
  background: linear-gradient(white, rgba(170, 236, 241, 0.726));
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  #span {
    width: 17vw;
    padding-bottom: 1vh;
    margin-bottom: 2vh;
    border-bottom: 4px solid rgb(47, 65, 223);
  }
  .thirdslide {
    margin-left: 0;
    width: 100vw;
  }
  .fit {
    width: 100%;
    display: flex;
    margin-left: 0;
    overflow-x: hidden;
    margin-bottom: 3vh;
    margin-top: 3vh;
    justify-content: space-between;
  }
  * {
    overflow: hidden;
  }
  .mx2 {
    transform: scale(0.8);
  }
}
</style>
